"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEmptyArrayMetadata = buildEmptyArrayMetadata;
function buildEmptyArrayMetadata() {
    return [];
}
//# sourceMappingURL=buildEmptyArrayMetadata.js.map